module.exports = __webpack_public_path__ + "cancellara-dist/img/timeswapp.2e550f5d.png";